define('responsive-game-feed/app/scripts/models/Feed',['require','exports','module','../utils/Utils','../utils/logger','jpath/jpath'],function(require, exports, module) {
    'use strict';

    var Utils = require("../utils/Utils");
    var logg  = require( "../utils/logger" );
    var Jpath = require( "jpath/jpath" );
    var firstload = true;
   

    function Feed(options) {

        this.options = $.extend(true, {}, this.options, options);
        this.poll = false;
        this.config = options;
        this.timer = null;
        this.dataIds = "";
        this.count = 0;
    };

    Feed.prototype = {

        /**
         * OBJECT DESCRIPTION
         */
        options: {},
        
        events: {
          EVENT_LOAD_SUCCESS : "success",
          EVENT_LOAD_ERROR : "error",
          EVENT_DATA_PARSED_SUCCESS : "dataParsedSuccess"
        },


        start: function() {
            this.poll = this.config.liveMode == true;
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
        },

        stop: function() {
           this.poll = false;
	       if( this.timer ){
		       clearTimeout(this.timer );
		       this.timer = null;
	       }
        },

        onTimeFetch: function(time) {

            if (this.poll) {
                this.timer = setTimeout($.proxy(this.fetch, this), time || 10000);
            }

        },

        getNewEntries: function(data) {
            var i;
            var temp = [];
            var $this = $(this);
            var data  = (data.items) ? data.items : data;
            


            if (this.dataIds === "" && data.length > 0) {
                this.dataIds = Jpath.filter(data, "guid").join() + ",";
                $this.trigger(this.events["EVENT_DATA_PARSED_SUCCESS"], {
                        data: data
                });

                return false;
            } 
            
            
           
            for (i = 0; i < data.length; i++) {
               
                var guid = data[i].guid;
                var totalItems = data;
                var totalItemsLength = totalItems.length;
                var newItem = totalItems[i];
                var testEntry = $("#"+ guid);
                
                if (this.dataIds.indexOf(guid + ",") < 0) {
                    this.dataIds += guid + ",";
                    temp.push(newItem);        
                    //console.log("New Item: " + guid);                    
                } else if (this.dataIds.indexOf(guid + ",") !== -1 && testEntry.attr("data-timegen") !== data[i].time_gen){
                   newItem.updated = true;
                   temp.push(newItem);
                   //console.log("Updated Item: " + guid);
                   
                }
                
                
                
                if (i === totalItemsLength - 1 && temp.length > 0) {
                //logg.debug("New Dataset:temp - " + temp.length);
                
                $this.trigger(this.events["EVENT_DATA_PARSED_SUCCESS"], {
                        data: temp
                });
                
                }
            }

        },
        
    
        fetch: function() {
            var that = this;
            var defer = $.Deferred();
            var test = this.count;
            var url =  Utils.getNewFeedURL(this.config);
            //var url = "/bower_components/responsive-game-feed/app/scripts/json/color.json";
            //logg.info("URL for request: " + url);
            
            $.ajax({
                url: url,
                dataType: "json",
                // contentType : false,
                // accepts : "gzip,deflate",
                success: function(data, status, xhr) {
                    if (data.items && data.items.length === 0) {
                     $(that).trigger(that.events["EVENT_LOAD_ERROR"]);
                     return false;
                    }
                    
                    $(that).trigger(that.events["EVENT_LOAD_SUCCESS"], {
                        data: data
                    });
                                       
                },
                error: function() {
                    $(that).trigger(that.events["EVENT_LOAD_ERROR"]);
                }
            })
          }
            
     
    };

    return Feed;

});

